import { Eye, EyeOff } from "lucide-react";
import { type KeyboardEvent, useState } from "react";
import { TextField, type TextFieldProps } from "./text-field";

/** Password input with a show/hide toggle and a Caps Lock warning. */
export function PasswordField({
  hint,
  onKeyUp,
  onKeyDown,
  ...props
}: Omit<TextFieldProps, "type" | "trailing">) {
  const [visible, setVisible] = useState(false);
  const [capsLock, setCapsLock] = useState(false);

  const trackCapsLock = (event: KeyboardEvent<HTMLInputElement>) => {
    if (typeof event.getModifierState === "function")
      setCapsLock(event.getModifierState("CapsLock"));
  };

  return (
    <TextField
      {...props}
      type={visible ? "text" : "password"}
      autoCapitalize="none"
      autoCorrect="off"
      spellCheck={false}
      hint={capsLock ? "Caps Lock is on" : hint}
      onKeyDown={(event) => {
        trackCapsLock(event);
        onKeyDown?.(event);
      }}
      onKeyUp={(event) => {
        trackCapsLock(event);
        onKeyUp?.(event);
      }}
      trailing={
        <button
          type="button"
          onClick={() => setVisible((value) => !value)}
          aria-label={visible ? "Hide password" : "Show password"}
          aria-pressed={visible}
          className="grid size-10 cursor-pointer place-items-center rounded-md text-ink-3 hover:bg-surface-2 hover:text-ink md:size-8"
        >
          {visible ? (
            <EyeOff className="size-[18px]" strokeWidth={1.5} />
          ) : (
            <Eye className="size-[18px]" strokeWidth={1.5} />
          )}
        </button>
      }
    />
  );
}
